import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useCallback, useContext } from 'react';
import { useIsLoggedIn } from '~/context/common/UserContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { Purchasing } from '~/contracts/vdp';
import fetchUserPurchasing from '~/services/vdp/fetchUserPurchasing';
import { generateErrorLogger } from '~/utilities/loggers';

export function useGetUserPurchasingGetter() {
  const {
    purchasing: { setData, setError, setLoading }
  } = useContext(UserVehicleContext);

  return useCallback<
    (controller?: AbortController) => Promise<Purchasing | null>
  >(
    async controller => {
      const errorLogger = generateErrorLogger(
        'Get user purchasing',
        {},
        { callback: setError, controller }
      );

      try {
        setLoading();

        const { hasActiveCart, ...details } =
          await fetchUserPurchasing(controller);
        const purchasing = hasActiveCart ? details : null;

        setData(purchasing);

        return purchasing;
      } catch (err) {
        errorLogger(err);

        return null;
      }
    },
    [setData, setError, setLoading]
  );
}

export default function useGetUserPurchasing() {
  const { fetchVehicleAvailabilityFlag } = useContext(UserVehicleContext);
  const isLoggedIn = useIsLoggedIn();
  const getUserPurchasing = useGetUserPurchasingGetter();

  useEffectWithController(
    controller => {
      if (isLoggedIn) getUserPurchasing(controller);
    },
    [fetchVehicleAvailabilityFlag, getUserPurchasing, isLoggedIn]
  );
}
